var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "1200px" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.salvar }
                },
                [_vm._v(" Salvar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Configurar tarefas do dia" } }),
      _c(
        "div",
        [
          _vm.loadingData
            ? _c("v-row", { attrs: { justify: "center", align: "center" } }, [
                _c(
                  "div",
                  { staticClass: "text-center ma-12 w-100" },
                  [
                    _c("v-progress-circular", {
                      attrs: { size: 50, color: "primary", indeterminate: "" }
                    })
                  ],
                  1
                )
              ])
            : _c(
                "div",
                [
                  _c("v-select", {
                    attrs: {
                      items: Object.keys(_vm.dados.campos_tarefas || {}),
                      label: "Tarefa"
                    },
                    model: {
                      value: _vm.task_type,
                      callback: function($$v) {
                        _vm.task_type = $$v
                      },
                      expression: "task_type"
                    }
                  }),
                  _c("Task", {
                    staticClass: "elevation-2",
                    staticStyle: {
                      "background-color": "var(--gray-2)",
                      padding: "10px",
                      "border-radius": "12px",
                      margin: "10px 0px"
                    },
                    attrs: {
                      campos: _vm.tipoTarefaSelecionada,
                      dados: {},
                      acao: _vm.task_type
                    }
                  }),
                  _vm.tipoTarefaSelecionada.campo_parametro
                    ? _c(
                        "v-row",
                        { attrs: { hidden: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "10" }
                            },
                            [
                              _c("p", [
                                _vm._v("Tarefa para verificar se o campo")
                              ]),
                              _c("v-select", {
                                staticClass: "ml-2",
                                attrs: {
                                  items:
                                    _vm.tipoTarefaSelecionada.campo_parametro,
                                  label: "Campo Parametro"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("p", [_vm._v("é")]),
                              _c("v-select", {
                                staticClass: "ml-2",
                                attrs: {
                                  items:
                                    _vm.tipoTarefaSelecionada
                                      .tipo_comparacao_parametro,
                                  label: "Tipo comparacao"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "5" }
                            },
                            [
                              _vm.tipoTarefaSelecionada.valor_parametro.length
                                ? _c("v-select", {
                                    staticClass: "col-3",
                                    attrs: {
                                      items:
                                        _vm.tipoTarefaSelecionada
                                          .valor_parametro,
                                      label: "Valor parametro"
                                    }
                                  })
                                : _c("v-text-field", {
                                    attrs: { label: "Valor parametro" }
                                  }),
                              _c("p", [
                                _vm._v(
                                  " ( " +
                                    _vm._s(
                                      _vm.tipoTarefaSelecionada
                                        .tipo_dado_parametro[0]
                                    ) +
                                    " ) "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tipoTarefaSelecionada.campo_parametro_v2
                    ? _c(
                        "v-row",
                        { attrs: { hidden: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "10" }
                            },
                            [
                              _c("p", [_vm._v(" Considerando que o campo ")]),
                              _c("v-select", {
                                staticClass: "ml-2",
                                attrs: {
                                  items:
                                    _vm.tipoTarefaSelecionada
                                      .campo_parametro_v2,
                                  label: "Campo Parametro 2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("p", [_vm._v(" é ")]),
                              _c("v-select", {
                                staticClass: "ml-2",
                                attrs: {
                                  items:
                                    _vm.tipoTarefaSelecionada
                                      .tipo_comparacao_parametro_v2,
                                  label: "Tipo comparacao 2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-baseline",
                              attrs: { cols: "5" }
                            },
                            [
                              _vm.tipoTarefaSelecionada.valor_parametro_v2
                                .length
                                ? _c("v-select", {
                                    attrs: {
                                      items:
                                        _vm.tipoTarefaSelecionada
                                          .valor_parametro_v2,
                                      label: "Valor parametro 2"
                                    }
                                  })
                                : _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: { label: "Valor parametro 2" }
                                  }),
                              _vm._v(
                                " ( " +
                                  _vm._s(
                                    _vm.tipoTarefaSelecionada
                                      .tipo_dado_parametro_v2[0]
                                  ) +
                                  " ) "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("hr"),
                  _vm._l(_vm.dados.campos_tarefas, function(t, i) {
                    return _c(
                      "div",
                      { attrs: { hidden: "" } },
                      [
                        _c("small", [_vm._v(_vm._s(t))]),
                        _c("small", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(i))
                        ]),
                        t.campo_parametro
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-baseline",
                                    attrs: { cols: "10" }
                                  },
                                  [
                                    _c("p", [
                                      _vm._v("Tarefa para verificar se o campo")
                                    ]),
                                    _c("v-select", {
                                      staticClass: "ml-2",
                                      attrs: {
                                        items: t.campo_parametro,
                                        label: "Campo Parametro"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-baseline",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("p", [_vm._v("é")]),
                                    _c("v-select", {
                                      staticClass: "ml-2",
                                      attrs: {
                                        items: t.tipo_comparacao_parametro,
                                        label: "Tipo comparacao"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-baseline",
                                    attrs: { cols: "5" }
                                  },
                                  [
                                    t.valor_parametro.length
                                      ? _c("v-select", {
                                          staticClass: "col-3",
                                          attrs: {
                                            items: t.valor_parametro,
                                            label: "Valor parametro"
                                          }
                                        })
                                      : _c("v-text-field", {
                                          attrs: { label: "Valor parametro" }
                                        }),
                                    _c("p", [
                                      _vm._v(
                                        " ( " +
                                          _vm._s(t.tipo_dado_parametro[0]) +
                                          " ) "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        t.campo_parametro_v2
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-baseline",
                                    attrs: { cols: "10" }
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(" Considerando que o campo ")
                                    ]),
                                    _c("v-select", {
                                      staticClass: "ml-2",
                                      attrs: {
                                        items: t.campo_parametro_v2,
                                        label: "Campo Parametro 2"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-baseline",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("p", [_vm._v(" é ")]),
                                    _c("v-select", {
                                      staticClass: "ml-2",
                                      attrs: {
                                        items: t.tipo_comparacao_parametro_v2,
                                        label: "Tipo comparacao 2"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-baseline",
                                    attrs: { cols: "5" }
                                  },
                                  [
                                    t.valor_parametro_v2.length
                                      ? _c("v-select", {
                                          attrs: {
                                            items: t.valor_parametro_v2,
                                            label: "Valor parametro 2"
                                          }
                                        })
                                      : _c("v-text-field", {
                                          staticClass: "mr-2",
                                          attrs: { label: "Valor parametro 2" }
                                        }),
                                    _vm._v(
                                      " ( " +
                                        _vm._s(t.tipo_dado_parametro_v2[0]) +
                                        " ) "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("hr"),
                        _c("br"),
                        _c("br")
                      ],
                      1
                    )
                  }),
                  _vm._l(_vm.dados.dados_tarefa, function(t) {
                    return _c(
                      "div",
                      [
                        _c("Task", {
                          staticClass: "elevation-2",
                          staticStyle: {
                            "background-color": "var(--gray-2)",
                            padding: "10px",
                            "border-radius": "12px",
                            margin: "15px 0px"
                          },
                          attrs: {
                            campos: _vm.dados.campos_tarefas[t.nome_funcao],
                            dados: t,
                            acao: t.nome_funcao
                          }
                        }),
                        _c("small", { attrs: { hidden: "" } }, [
                          _vm._v(" " + _vm._s(t) + " "),
                          _c("p", [_vm._v(" " + _vm._s(t.acao) + " ")]),
                          _c("p", [_vm._v(" " + _vm._s(t.descricao) + " ")]),
                          _c("p", [
                            _vm._v(" " + _vm._s(t.descricao_parametro) + " ")
                          ]),
                          _c("p", [
                            _vm._v(" " + _vm._s(t.descricao_parametro_2) + " ")
                          ])
                        ]),
                        _c("v-row", { attrs: { hidden: "" } }, [
                          _c("label", [
                            _vm._v(
                              " Executada a cada " +
                                _vm._s(t.frequencia) +
                                " " +
                                _vm._s(t.escala_frequencia) +
                                " "
                            )
                          ])
                        ]),
                        t.campo_parametro
                          ? _c("v-row", { attrs: { hidden: "" } }, [
                              _c("label", [
                                _vm._v(
                                  " Tarefa para verificar se o campo " +
                                    _vm._s(t.campo_parametro) +
                                    " é " +
                                    _vm._s(t.tipo_comparacao_parametro) +
                                    " " +
                                    _vm._s(t.valor_parametro) +
                                    " ( " +
                                    _vm._s(t.tipo_dado_parametro) +
                                    ") "
                                )
                              ])
                            ])
                          : _vm._e(),
                        t.campo_parametro_v2
                          ? _c("v-row", { attrs: { hidden: "" } }, [
                              _c("label", [
                                _vm._v(
                                  " Contanto que " +
                                    _vm._s(t.campo_parametro_v2) +
                                    " seja " +
                                    _vm._s(t.tipo_comparacao_parametro_v2) +
                                    " " +
                                    _vm._s(t.valor_parametro_v2) +
                                    " ( t.tipo_dado_parametro_v2 ) "
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }